// Vue 3 日期时间格式化工具
// 注意：Vue 3 中移除了 filters，使用全局方法或组合式函数代替
import moment from 'moment';

// 设置moment国际化语言
moment.locale('zh-cn');

/**
 * 格式化日期
 * @param {string|Date} value - 日期值
 * @param {string} format - 格式化字符串
 * @returns {string} 格式化后的日期字符串
 */
export function dateFormat(value, format = 'YYYY-MM-DD HH:mm:ss') {
    return moment(value).format(format);
}

/**
 * 相对时间格式化
 * @param {string|Date} value - 日期值
 * @returns {string} 相对时间或详细时间
 */
export function dateFromNow(value) {
    // 相对时间大于一个月，显示详细时间
    if (moment().diff(moment(value)) > 2592000000) {
        return moment(value).format('YYYY-MM-DD HH:mm');
    }
    return moment(value).fromNow();
}

// 注册全局方法的辅助函数
export function registerDateMethods(app) {
    app.config.globalProperties.$dateFormat = dateFormat;
    app.config.globalProperties.$dateFromNow = dateFromNow;
}
